export class PlannerCardThumbnailModel {
  cardId: string = undefined;
  plannerGroupId: string = undefined;
  dayOfWeek: number = undefined; // (Mon = 1)
  weight: number = undefined;
  topicKey: string = undefined;
  cardTitle: string = undefined;
  thumbnailBackground: string = undefined;
  thumbnailSideBorder: string = undefined;
  plannerCardId: string = undefined;
  isCustomCard: boolean = false;
  associatedPlannerGroupId: string = undefined;
  // Not from API
  thumbnailWidth: number = 1;
  isPartOfPreviousDayCard: boolean = false;
  isMultiDayCard: boolean = false;
  sanitizedCardTitle: string = undefined;
  thumbnailStartingDayPlannerCardId: string = undefined;
}
